import {useGetUsersByTenantId, useRemoveUsersFromTenant} from 'hooks/useTenant';
import {UserInviteScopeLevelEnum} from 'models';
import {UserListingResponseModel} from 'models/tenant.model';
import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {sessionSelector} from 'store/auth/sessionSlice';
import {MembershipBaseSetting, MemberShipBaseSettingHandleComponent, userColumnsRelations} from 'views/settings/common';

export const TenantMemberSetting: React.FC = () => {
    const [data, setData] = useState<UserListingResponseModel[]>([]);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const {tenantId} = useSelector(sessionSelector);

    // Apis
    const {getUsersByTenantId, getUsersByTenantIdLoading, getUsersByTenantIdResponse} = useGetUsersByTenantId();

    const {removeUsersFromTenant, removeUsersFromTenantLoading, removeUsersFromTenantResponse} =
        useRemoveUsersFromTenant();
    //

    const handleSelectAll = (checked: boolean, allIds: string[]) => {
        setIsAllSelected(checked);
        setSelectedIds(checked ? allIds : []);
    };

    const handleRowSelect = (checked: boolean, id: string) => {
        setSelectedIds(prev => (checked ? [...prev, id] : prev.filter(selectedId => selectedId !== id)));
    };

    const handleAllDelelte = (ids: string[]) => {
        setData(prev => prev.filter(x => !ids.includes(x.id)));
    };

    const removeUsersHandler = () => {
        if (tenantId && selectedIds.length > 0) {
            removeUsersFromTenant({
                variables: {
                    request: {
                        tenantId: tenantId,
                        userIds: selectedIds,
                    },
                },
            });
        }
    };

    const memberShipBaseRef = useRef<MemberShipBaseSettingHandleComponent>(null);
    const handleEmailInvite = (values: string) => {
        memberShipBaseRef.current?.handleInviteUserEmails([values]);
    };
    const setIsDeleteAlertOpen = (val: boolean, id?: string) => {
        if (id) {
            setSelectedIds([id]);
        }
        if (memberShipBaseRef.current) {
            memberShipBaseRef.current.setAlertOpen(val);
        }
    };
    const columns = userColumnsRelations({
        selectedIds,
        isAllSelected,
        handleSelectAll,
        handleEmailInvite,
        handleRowSelect,
        setIsDeleteAlertOpen,
    });

    const handleRefreshData = () => {
        if (tenantId) {
            getUsersByTenantId({
                variables: {
                    tenantId: tenantId,
                },
            });
        }
    };
    // useEffects
    useEffect(() => {
        if (tenantId) {
            getUsersByTenantId({
                variables: {
                    tenantId: tenantId,
                },
            });
        }
    }, []);

    useEffect(() => {
        if (!getUsersByTenantIdLoading && getUsersByTenantIdResponse) {
            setData(getUsersByTenantIdResponse);
        }
    }, [getUsersByTenantIdResponse, getUsersByTenantIdLoading]);

    useEffect(() => {
        if (!removeUsersFromTenantLoading && removeUsersFromTenantResponse) {
            handleAllDelelte(selectedIds);
            setIsDeleteAlertOpen(false);
            setSelectedIds([]);
        }
    }, [removeUsersFromTenantLoading, removeUsersFromTenantResponse]);

    if (!tenantId) return null;

    return (
        <MembershipBaseSetting
            columns={columns}
            data={data}
            ref={memberShipBaseRef}
            scopeId={tenantId}
            handleRefreshData={handleRefreshData}
            scopeLevel={UserInviteScopeLevelEnum.Tenant}
            removeUserHandler={removeUsersHandler}
            searchValue={searchValue}
            selectedIds={selectedIds}
            setSearchValue={setSearchValue}
        />
    );
};

export default TenantMemberSetting;
